import { Link } from "react-router-dom";
import fallbackImage from "../assets/images/service.jpg";

export default function BlogCard({ blog }) {
  const cover = blog.coverImage || fallbackImage;

  const formattedDate = blog.publishedAt
    ? new Date(blog.publishedAt).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
    : null;

  return (
    <Link
      to={`/blog/${blog.slug || blog.id}`}
      className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col group"
    >
      {/* Cover */}
      <div className="relative overflow-hidden aspect-[16/9]">
        <img
          src={cover}
          alt={blog.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {blog.category && (
          <span className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm text-primary font-manrope-semibold text-xs px-3 py-1 rounded-full">
            {blog.category}
          </span>
        )}
      </div>

      {/* Body */}
      <div className="p-5 flex flex-col gap-3 flex-1">
        <h3 className="font-manrope-bold text-base text-black leading-snug line-clamp-2 group-hover:text-primary transition-colors">
          {blog.title}
        </h3>

        {blog.excerpt && (
          <p className="font-manrope-regular text-sm text-secondary leading-relaxed line-clamp-2">
            {blog.excerpt}
          </p>
        )}

        {/* Footer */}
        <div className="flex items-center justify-between mt-auto pt-3 border-t border-gray-100">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
              <span className="text-white font-manrope-bold text-[10px]">
                {(blog.author || "C")[0].toUpperCase()}
              </span>
            </div>
            <span className="font-manrope-medium text-xs text-secondary truncate max-w-[100px]">
              {blog.author || "Contentour Bonaire"}
            </span>
          </div>

          <div className="flex items-center gap-3">
            {blog.readTime && (
              <span className="font-manrope-regular text-xs text-secondary flex items-center gap-1">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-3.5 h-3.5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                {blog.readTime} min
              </span>
            )}
            {formattedDate && (
              <span className="font-manrope-regular text-xs text-gray-400">{formattedDate}</span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}
